import React from 'react';
import ProduitServiceCard from './ProduitServiceCard';
import { Package } from 'lucide-react';

const ProduitServiceList = ({ produits, onView, onEdit, onDelete, loading }) => {
  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#FF6B00]"></div>
      </div>
    );
  }

  if (!produits || produits.length === 0) {
    return (
      <div className="bg-white rounded-lg shadow p-12 text-center">
        <Package className="w-16 h-16 text-gray-300 mx-auto mb-4" />
        <h3 className="text-lg font-medium text-gray-900 mb-2">
          Aucun produit ou service trouvé
        </h3>
        <p className="text-gray-500">
          Aucun produit ou service ne correspond à vos critères de recherche.
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {produits.map((produit) => (
        <ProduitServiceCard
          key={produit.id}
          produit={produit}
          onView={onView}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      ))}
    </div>
  );
};

export default ProduitServiceList;
